/* eslint-disable */
import Qs from 'qs';
import store from '@/store';
import EasyResponse from 'easyjs/lib/Http/Response';
const customStorage = require('@/plugins/customStorage').default;
import { DelayFunction } from '../utils/delay';

const axios = require('axios');
let apiKey = process.env.VUE_APP_API_KEY;

global.delayFunction = global.delayFunction || new DelayFunction();

const { delayFunction } = global;

delayFunction.fn = () => {
  store.commit('store/setLoading', false);
};

if (typeof token !== 'undefined') {
  /* eslint-disable */
  apiKey = token;
  /* eslint-enable */
}

if (typeof envName !== 'undefined') {
  /* eslint-disable */
  apiEnv = envName;
  /* eslint-enable */
}
/* eslint-enable */

const url = window.location.search.substr(1).split('&');
/* eslint-disable */
for (const i in url) {
  if (url[i].split('=')[0] === 'client') {
    apiKey = url[i].split('=')[1];
  }

  if (url[i].split('=')[0] === 'schema') {
    localStorage.setItem('schema', url[i].split('=')[1]);
  }
}

// axios.defaults.headers.common['x-api-key'] = apiKey
axios.defaults.headers.common['x-api-env'] = customStorage().get.item(
  'easy.account.x-api-env'
);
// axios.defaults.headers.common['content-type'] = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] =
  'application/json, text/plain, text/html';

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return error;
  }
);

export default async (
  resource,
  method,
  httpMethod = 'get',
  data = {},
  headers = {},
  showLoading,
  timeLoadingClose = 1500
) => {
  let sUrl =
    `${process.env.VUE_APP_API}/${resource}/${process.env.VUE_APP_API_VERSION}` +
    (method ? `/${method}` : '');
  /* No caso de método get converte o onjeto para query string */
  if (httpMethod === 'get') {
    sUrl += '?' + Qs.stringify(data);
  }
  if (showLoading) {
    store.commit('store/setLoading', true);
  }
  /* eslint-disable */
  return await axios({
    url: sUrl,
    crossdomain: true,
    method: httpMethod,
    data: data,
    headers: headers,
  })
    .then((response) => {
      if (showLoading) {
        delayFunction.addDelay();
      }
      return new EasyResponse(
        response.data.response.data || null,
        response.data.response.code || 200,
        response.data.response.errors || [],
        response.data.response.pagination || {}
      );
    })
    .catch((error) => {
      setTimeout(
        () => store.commit('store/setLoading', false),
        timeLoadingClose
      );
    });
};
/* eslint-enable */
